interface IContentPageProps extends React.HTMLProps<HTMLElement> {
  // title?: string;
  // breadcrumb?: boolean;
  fluid?: boolean;
}

export default function ContentPage({children, fluid}:IContentPageProps){
  const classFluid = fluid?"pagedefault-content-fluid":"";

  return (
    <div className={"pagedefault-content "+(classFluid)}>
      <div className="pagedefault-content-d"></div>
      <div className="pagedefault-content-d"></div>
      {children}
    </div>
  )
}